import { ComponentStyleConfig } from '@chakra-ui/react'

export default <ComponentStyleConfig>{
  baseStyle: {
    _focus: { boxShadow: 'none' },
  },
}
